import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { INewsScheme } from './models';

dayjs.extend(customParseFormat);

export const articleSchemaJson = (data: INewsScheme, path: string) => ({
  '@context': 'https://schema.org/',
  '@type': 'Article',
  mainEntityOfPage: `https://akam.uz${path}`,
  headline: data?.name,
  name: data?.name,
  datePublished: data?.created_time ? dayjs(data?.created_time, 'DD.MM.YYYY HH:mm').toISOString() : '',
  dateModified: data?.created_time ? dayjs(data?.created_time, 'DD.MM.YYYY HH:mm').toISOString() : '',
  articleSection: data?.category_name,
  description: data?.description ? data.description.replace(/<[^>]+>/g, '') : '',
  articleBody: data?.description ? data.description.replace(/<[^>]+>/g, '') : '',
  image: data?.image,
  publisher: {
    '@type': 'Organization',
    name: 'Akam',
    telephone: '+998 94 250 81 01',
    logo: {
      '@type': 'ImageObject',
      url: 'https://akam.uz/favicon.ico'
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: "Toshkent, ko'cha. Аxmad Donish, 20А 100180",
      addressLocality: 'Tashkent',
      addressCountry: {
        '@type': 'Country',
        name: 'Uzbekistan'
      },
      postalCode: '100180'
    },
    image: {
      '@type': 'ImageObject',
      url: 'https://akam.uz/favicon.ico'
    }
  },
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '5',
    reviewCount: '5',
    itemReviewed: {
      '@type': 'Book',
      name: data?.name,
      url: `https://akam.uz${path}`
    }
  },
  author: {
    '@type': 'Organization',
    name: 'Akam',
    url: 'https://akam.uz',
    logo: {
      '@type': 'ImageObject',
      url: 'https://akam.uz/favicon.ico'
    },
    image: {
      '@type': 'ImageObject',
      url: 'https://akam.uz/favicon.ico'
    }
  }
});
